import { Breadcrumb } from "@/components/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/api-keys")({
  component: () => (
    <Breadcrumb label="API Keys" to="/api-keys">
      <Outlet />
    </Breadcrumb>
  ),
});
